module.exports = __webpack_public_path__ + "13cf6dd79b9f22df0b15e3b19e92ac50.pdf";